import React, { Component } from "react";
import { Button, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { GetProductDetails } from "../../../../services";
import MainCategorylist from "../../../../common/category/main-category";
import Loader from "../../../../loader";
import { NotificationManager } from "react-notifications";
import swal from "sweetalert";

export default class Edit extends Component {
  constructor(props) {
    super(props);
    let self = this.props.location.state.row;

    this.state = {
      selectedCategoryIds: [],
      loading: false,
      blockHide: false,
      productId: self.id,
      name: "",
      slug: "",
      status: "",
      image: "",
      currentImage: "",
      sortDesc: "",
      height: "",
      stitches: "",
      tags: "",
      variants: [],
      predefinedVariantNames: [
        "DST-BERNINA-14x8",
        "DST-BROTHER-V3SE-12x8",
        "DST-FULL",
        "JEF-USHA-450-11x8",
        "JEF-USHA-550-14x8",
        "PES-BROTHER-BP3600-14x9.5",
      ],
    };
  }

  handleBack() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    try {
      const { productId } = this.state;
      const result = await GetProductDetails.getAdmProductListById(productId);

      if (result) {
        this.setState({
          name: result.productData.name,
          tags: result.productData.tags,
          slug: result.productData.slug,
          status: result.productData.status === "active" ? 1 : 0,
          sortDesc: result.productData.sortDesc,
          height: result.productData.height,
          stitches: result.productData.stitches,
          selectedCategoryIds: result.productData.categories
            ? result.productData.categories.map((cat) => ({
                id: cat.id,
                name: cat.name,
              }))
            : [],
          //  variants: result.productData.variants,
          variants: result.productData.variants.map((v) => {
            let path = v.variantPath || "";

            if (path.toLowerCase().endsWith(".zip")) {
              path = path.slice(0, -4);
            }

            return {
              ...v,
              variantPath: `${path}.zip`,
            };
          }),

          currentImage: result.productData.photo || "",
          loading: false,
        });
      } else {
        NotificationManager.error("Failed to fetch product details.");
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      NotificationManager.error(
        "An error occurred while fetching product details.",
      );
      this.setState({ loading: false });
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFileChange = (event) => {
    this.setState({ image: event.target.files[0] });
  };

  handleContentChange = (contentHtml) => {
    this.setState({
      content: contentHtml,
    });
  };

  handleCategory = (value) => {
    // value should be {id, name}
    if (!this.state.selectedCategoryIds.some((cat) => cat.id === value.id)) {
      this.setState((prevState) => ({
        selectedCategoryIds: [...prevState.selectedCategoryIds, value],
        blockhide: true,
      }));
    }
  };

  handleRemoveCategory = (categoryId) => {
    this.setState((prevState) => ({
      selectedCategoryIds: prevState.selectedCategoryIds.filter(
        (cat) => cat.id !== categoryId,
      ),
    }));
  };

  handleAddVariant = () => {
    this.setState((prevState) => ({
      variants: [
        ...prevState.variants,
        { variantName: "", variantPrice: 0, variantPath: "" },
      ],
    }));
  };

  handleRemoveVariant = (index) => {
    this.setState((prevState) => ({
      variants: prevState.variants.filter((_, i) => i !== index),
    }));
  };

  // handleVariantChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const newVariants = [...this.state.variants];
  //   newVariants[index] = { ...newVariants[index], [name]: value };
  //   this.setState({ variants: newVariants });
  // };

  handleVariantChange = (index, e) => {
    const { name, value } = e.target;
    const newVariants = [...this.state.variants];

    if (name === "variantPath") {
      let fileName = value.trim();

      // remove .zip if user types it
      if (fileName.toLowerCase().endsWith(".zip")) {
        fileName = fileName.slice(0, -4);
      }

      // always append .zip
      fileName = `${fileName}.zip`;

      newVariants[index] = {
        ...newVariants[index],
        [name]: fileName,
      };
    } else {
      newVariants[index] = {
        ...newVariants[index],
        [name]: value,
      };
    }

    this.setState({ variants: newVariants });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const {
      selectedCategoryIds,
      productId,
      image,
      name,
      slug,
      status,
      sortDesc,
      variants,
      height,
      stitches,
      tags,
    } = this.state;
    const formData = new FormData();
    formData.append(
      "categoryIds",
      JSON.stringify(selectedCategoryIds.map((cat) => cat.id)),
    );

    formData.append("productId", productId);
    formData.append("name", name);
    formData.append("slug", slug);
    formData.append("status", status);
    formData.append("photo", image);
    formData.append("status", status);
    formData.append("sortDesc", sortDesc);
    formData.append("height", height);
    formData.append("stitches", stitches);
    formData.append("tags", tags);

    // Append variants data
    variants.forEach((variant, index) => {
      formData.append(`variants[${index}][variantName]`, variant.variantName);
      formData.append(`variants[${index}][variantPrice]`, variant.variantPrice);
      formData.append(`variants[${index}][variantPath]`, variant.variantPath);
    });

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    swal({
      title: "Are you sure?",
      text: "You want to Update Product",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        let list = await GetProductDetails.getUpdateProduct(formData, config);
        if (list) {
          this.setState({ loading: false });
          this.props.history.push("/admin/product/list");
        } else {
          this.setState({ loading: false });
          NotificationManager.error("Please! Check input field", "Input Field");
        }
      }
    });
  };

  render() {
    const { loading, variants, predefinedVariantNames, selectedCategoryIds } =
      this.state;
    const sortedVariants = variants.sort((a, b) => {
      const indexA = predefinedVariantNames.indexOf(a.variantName);
      const indexB = predefinedVariantNames.indexOf(b.variantName);
      return indexA - indexB; // Ascending order based on predefined list
    });
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">Products</h2>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button variant="contained" onClick={(e) => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">
            <a href="/">Dashboard</a>
          </li>
          <li className="breadcrumb-item">
            <a href="/admin/product/create">Products</a>
          </li>
          <li className="breadcrumb-item active">Update Product</li>
        </ol>
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="card card-static-2 mb-30">
              <div className="card-body-table">
                <div className="news-content-right pd-20">
                  <div className="form-group">
                    <label className="form-label">Category*</label>
                    <MainCategorylist
                      selectedCategories={selectedCategoryIds}
                      handleCategorySelect={this.handleCategory}
                      handleCategoryRemove={this.handleRemoveCategory}
                    />

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginTop: "10px",
                      }}
                    >
                      {selectedCategoryIds.map((cat, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#e3f2fd",
                            color: "#1565c0",
                            padding: "6px 10px",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {cat.name}
                          <IconButton
                            size="small"
                            onClick={() => this.handleRemoveCategory(cat.id)}
                            style={{ marginLeft: "6px", color: "#d32f2f" }}
                          >
                            <Close fontSize="small" />
                          </IconButton>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mb-30">
              <div className="card-title-2">
                <h4>Update Product</h4>
              </div>
              <div className="card-body-table">
                {loading ? <Loader /> : ""}
                <div className="news-content-right pd-20">
                  <div className="row">
                    <div className="col-lg-4 col-md-4">
                      <div className="form-group">
                        <label className="form-label">Product Name*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Product Name"
                          name="name"
                          value={this.state.name}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Slug*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Slug"
                          name="slug"
                          value={this.state.slug}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Product Image*</label>
                        <input
                          type="file"
                          className="form-control"
                          name="image"
                          onChange={this.onFileChange}
                        />

                        {/* Preview section */}
                        <div style={{ marginTop: "10px" }}>
                          {/* If new image selected, show its preview */}
                          {this.state.image ? (
                            <img
                              src={URL.createObjectURL(this.state.image)}
                              alt="New Preview"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                                border: "1px solid #ddd",
                              }}
                            />
                          ) : this.state.currentImage ? (
                            /* Otherwise, show current backend image */
                            <img
                              src={this.state.currentImage}
                              alt="Current Product"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                                border: "1px solid #ddd",
                              }}
                              crossOrigin="anonymous"
                            />
                          ) : (
                            <p>No image available</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: "2rem" }}>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Status*</label>
                        <select
                          id="status"
                          name="status"
                          className="form-control"
                          value={this.state.status}
                          onChange={(e) => this.handleChange(e)}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Height*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Height (e.g., 10x6, 6x4)"
                          name="height"
                          value={this.state.height}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Stitches*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Stitches (e.g., 17000, 8880)"
                          name="stitches"
                          value={this.state.stitches}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Tags*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Tags (e.g., allover, peacocks)"
                          name="tags"
                          value={this.state.tags}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row" style={{ paddingTop: "2rem" }}>
                    <div className="form-group">
                      <label className="form-label">Sort Description*</label>
                      <textarea
                        rows="4"
                        cols="100"
                        className="form-control"
                        name="sortDesc"
                        value={this.state.sortDesc}
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                  </div>

                  {/* Variants Section */}
                  <div className="variants-section">
                    <h4>Product Variants</h4>
                    <div
                      style={{
                        background: "#e3f2fd",
                        border: "1px solid #90caf9",
                        padding: "10px 14px",
                        borderRadius: "6px",
                        marginBottom: "15px",
                        color: "#0d47a1",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      📦 Variant File Rule: Enter <b>file name only</b> —{" "}
                      <b>.zip will be added automatically</b>
                      <br />
                      Example: <i>DST-BERNINA-14x8</i> →{" "}
                      <i>DST-BERNINA-14x8.zip</i>
                    </div>
                    {sortedVariants.map((variant, index) => (
                      <div className="row" key={index}>
                        <div className="col-lg-3 col-md-3">
                          <div className="form-group">
                            <label className="form-label">Variant Name*</label>
                            <select
                              className="form-control"
                              name="variantName"
                              value={variant.variantName}
                              onChange={(e) =>
                                this.handleVariantChange(index, e)
                              }
                            >
                              <option value="">Select Variant</option>
                              {predefinedVariantNames.map((name, i) => (
                                <option key={i} value={name}>
                                  {name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-2">
                          <div className="form-group">
                            <label className="form-label">Variant Price*</label>
                            <input
                              type="number"
                              className="form-control"
                              name="variantPrice"
                              value={variant.variantPrice}
                              onChange={(e) =>
                                this.handleVariantChange(index, e)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-2">
                          <div className="form-group">
                            <label className="form-label">
                              Variant File Name*
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="variantPath"
                              value={variant.variantPath}
                              onChange={(e) =>
                                this.handleVariantChange(index, e)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-2">
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => this.handleRemoveVariant(index)}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    ))}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleAddVariant}
                    >
                      Add Variant
                    </Button>
                  </div>

                  <button
                    className="save-btn hover-btn"
                    type="submit"
                    onClick={this.handleSubmit}
                  >
                    Update Product
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/product/edit/index.jsx